export const programConfigs = {
    // -------------------------------------------------------------
    // 1. DAY REHAB PROGRAM
    // -------------------------------------------------------------
    DAY_REHAB_PROGRAM: {
        phases: [
            {
                id: 1,
                name: "Phase-01",
                forms: [
                    "Inquiry Form",
                    "Consent Form",
                ],
            },
            {
                id: 2,
                name: "Phase-02",
                forms: [
                    "Integrated Assessment Form",
                ],
            },
            {
                id: 3,
                name: "Phase-03",
                forms: [
                    "Exercise Schedule",
                    "Medication Sheet",
                ],
            },
            {
                id: 4,
                name: "Phase-04",
                forms: [
                    "Anxiety Form",
                    "BDI-II Form",
                    "Beck Suicide Intent Scale",
                    "BPRS Form",
                    "Depression Patient Health Question",
                    "Discharge Advice",
                    "Discharge Summary",
                    "Family Meeting Minutes",
                    "IRP (Individual Rehabilitation Plan)",
                    "Obsessive Compulsive Disorder Test",
                    "Progress Notes Record (RPR)",
                    "Pros Form",
                    "Qol2",
                    "YMRS Form",
                ],
            },
        ],
        formRoutes: {
            "Inquiry Form": "/inquiry",
            "Consent Form": "/consent",
            "Integrated Assessment Form": "/residential/phase-01/integrated-initial-assessment",
            "Exercise Schedule": "/exercise-schedule",
            "Medication Sheet": "/phase05/medication-sheets",
            "Anxiety Form": "/phase04/anxiety",
            "BDI-II Form": "/phase04/bdi",
            "Beck Suicide Intent Scale": "/phase04/suicide-intent",
            "BPRS Form": "/phase04/bprs",
            "Depression Patient Health Question": "/phase04/phq",
            "Discharge Advice": "/phase07/discharge-advice",
            "Discharge Summary": "/phase07/discharge-summary",
            "Family Meeting Minutes": "/phase05/family-meeting-minutes",
            "IRP (Individual Rehabilitation Plan)": "/phase05/individualised-rehab-plans",
            "Obsessive Compulsive Disorder Test": "/phase04/obsessive-compulsive-test",
            "Progress Notes Record (RPR)": "/phase05/progress-notes",
            "Pros Form": "/phase05/pros-assessments",
            "Qol2": "/phase04/qol",
            "YMRS Form": "/phase04/ymrs",
        },
    },

    // -------------------------------------------------------------
    // 2. HOME VISITATION PROGRAM
    // -------------------------------------------------------------
    HOME_VISITATION_PROGRAM: {
        phases: [
            {
                id: 1,
                name: "Phase-01",
                forms: [
                    "Inquiry Form",
                    "Consent Form",
                ],
            },
        ],
        formRoutes: {
            "Inquiry Form": "/inquiry",
            "Consent Form": "/consent",
        },
    },

    // -------------------------------------------------------------
    // 3. RESIDENTIAL REHAB PROGRAM
    // -------------------------------------------------------------
    RESIDENTIAL_REHAB_PROGRAM: {
        phases: [
            {
                id: 1,
                name: "Phase-01",
                forms: [
                    "Inquiry Form",
                    "Consent Form",
                ],
            },
            {
                id: 2,
                name: "Phase-02",
                forms: [
                    "Integrated Assessment Form",
                ],
            },
            {
                id: 3,
                name: "Phase-03",
                forms: [
                    // DISCHARGE SUMMARY - 4 TYPES
                    "Discharge Summary (Psychiatric)",
                    "Discharge Summary (Physician)",
                    "Discharge Summary (Nursing)",
                    "Discharge Summary (PRPS)",

                    "Psych Order",

                    // PROGRESS NOTES - 2 TYPES
                    "Progress Notes Record (Psychiatric) - RPR",
                    "Progress Notes Record (PRPS) - RPR",

                    "Progress Notes Record (Phsyician)[Sana]",
                    "ADL Record Sheet",
                    "Personal Belonging",
                    "Complaint Form",
                    "Escort Form [injection]",
                    "Exercise Schedule",
                    "Nursing Record",
                    "Depot injection Chart",
                    "Medication Sheet",
                    "Vitals Monitoring Chart",
                    "Anxiety Form",
                    "BDI-II Form",
                    "Beck Suicide Intent Scale",
                    "BPRS Form",
                    "Depression Patient Health Question",
                    "Family Meeting Minutes",
                    "IRP (Individual Rehabilitation Plan)",
                    "Obsessive Compulsive Disorder Test",
                    "Qol2",
                    "Tentative Family Plan",
                    "Pros Form",
                    "YMRS Form",
                ],
            },
            {
                id: 4,
                name: "Phase-04",
                forms: [
                    "Incident Report",
                    "Lama Policy",
                    "Referral Form",
                    "Relocation Policy",
                    "Safety Plan",
                    "Safety Plan (URDU)",
                    "Suicide Detail",
                    "Violence Detail",
                ],
            },
        ],
        formRoutes: {
            "Inquiry Form": "/inquiry",
            "Consent Form": "/consent",
            "Integrated Assessment Form": "/residential/phase-01/integrated-initial-assessment",

            // DISCHARGE SUMMARY - Same route, type_id will be passed in state
            "Discharge Summary (Psychiatric)": "/phase07/discharge-summary",
            "Discharge Summary (Physician)": "/phase07/discharge-summary",
            "Discharge Summary (Nursing)": "/phase07/discharge-summary",
            "Discharge Summary (PRPS)": "/phase07/discharge-summary",

            "Psych Order": "/phase03/psychiatrist-order",

            // PROGRESS NOTES - Same route, type_id will be passed in state
            "Progress Notes Record (Psychiatric) - RPR": "/phase05/progress-notes",
            "Progress Notes Record (PRPS) - RPR": "/phase05/progress-notes",

            "Progress Notes Record (Phsyician)[Sana]": "/phase05/sana-notes",
            "ADL Record Sheet": "/phase05/adl-record-sheet",
            "Personal Belonging": "/phase04/personal-belongings",
            "Complaint Form": "/phase03/complaint-form",
            "Escort Form [injection]": "/injections",
            "Exercise Schedule": "/exercise-schedule",
            "Nursing Record": "/phase05/nursing-records",
            "Depot injection Chart": "/phase05/depot-injections",
            "Medication Sheet": "/phase05/medication-sheets",
            "Vitals Monitoring Chart": "/phase05/vitals-monitor",
            "Anxiety Form": "/phase04/anxiety",
            "BDI-II Form": "/phase04/bdi",
            "Beck Suicide Intent Scale": "/phase04/suicide-intent",
            "BPRS Form": "/phase04/bprs",
            "Depression Patient Health Question": "/phase04/phq",
            "Family Meeting Minutes": "/phase05/family-meeting-minutes",
            "IRP (Individual Rehabilitation Plan)": "/phase05/individualised-rehab-plans",
            "Obsessive Compulsive Disorder Test": "/phase04/obsessive-compulsive-test",
            "Qol2": "/phase04/qol",
            "Tentative Family Plan": "/phase04/tentative-family-plan",
            "Pros Form": "/phase05/pros-assessments",
            "YMRS Form": "/phase04/ymrs",

            "Incident Report": "/phase05/incident-report",
            "Lama Policy": "/residential/optional/lama-form",
            "Referral Form": "/residential/optional/referral-form",
            "Relocation Policy": "/residential/optional/relocation-form",
            "Safety Plan": "/residential/optional/safety-plan",
            "Safety Plan (URDU)": "/residential/optional/safety-plan-urdu",
            "Suicide Detail": "/residential/optional/suicide-detail",
            "Violence Detail": "/residential/optional/violence-risk",
        },
    },
};